exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--panel__1jLk8{border-top-width:1px;border-style:solid;position:sticky;bottom:0;z-index:2;margin-left:0 !important}\n", ""]);

// exports
exports.locals = {
	"panel": "styles--panel__1jLk8"
};